export { default } from './components/LayerManager';
export { default as withContextFromProps } from './components/withContextFromProps';
export { default as withRenderTarget } from './components/withRenderTarget';
export { default as FocusLock } from './components/FocusLock';
export { default as Portal } from './components/Portal';
export { default as ScrollLock } from './components/ScrollLock';
export { Gateway, GatewayDest, GatewayProvider, GatewayRegistry } from './components/gateway';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/layer-manager/dist/esm/index.js
// module id = 5983
// module chunks = 0